import { USER_DETAILS } from "./user.types";

export const setUserDetails = (details) => {
  return {
    type: USER_DETAILS,
    payload: { details },
  };
};
